module.exports = __webpack_public_path__ + "img/homekv2.11e71958.jpg";